module.exports = __webpack_public_path__ + "static/media/sfchronicle.86cd4761.svg";